import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const CONTACT_API_URL = (
  process.env.REACT_APP_CONTACT_API_URL || "https://api.yashsoftsolution.com/api/v1/contactus"
).trim();

export const submitContact = createAsyncThunk(
  "contact/submitContact",
  async (formData, { rejectWithValue }) => {
    try {
      const payload = {
        name: formData?.name?.trim() || "",
        mobile: formData?.mobile?.trim() || "",
        subject: formData?.subject?.trim() || "",
        message: formData?.message?.trim() || "",
      };

      const res = await axios.post(CONTACT_API_URL, payload, {
        headers: { "Content-Type": "application/json" },
      });

      return res.data;
    } catch (err) {
      const errorPayload =
        err?.response?.data?.message || err?.response?.data || err?.message;
      return rejectWithValue(errorPayload);
    }
  }
);

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    loading: false,
    success: null,
    error: null,
  },
  reducers: {
    clearContactState: (state) => {
      state.loading = false;
      state.success = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContact.pending, (state) => {
        state.loading = true;
        state.success = null;
        state.error = null;
      })
      .addCase(submitContact.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
      })
      .addCase(submitContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearContactState } = contactSlice.actions;
export default contactSlice.reducer;
